import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnChanges, Input } from '@angular/core';
import { DataService } from '../shared/dataservice.service';
//import * as D3 from "d3";

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {

  constructor(public _dataService:DataService) { }

  ngOnInit() {
    this._dataService.currPageName = "Reports";
    this._dataService.additionalPageDetails = "";
  }
}
